import React from 'react';
import { useNumberFormat } from 'src/core/hooks/format';

interface ColliProps {
    colliEntity: string;
    amount: number;
}

export const Colli: React.FC<ColliProps> = ({ amount, colliEntity }) => {
    const formatColli = useNumberFormat()({
        postfix: colliEntity,
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
    });

    return <>{formatColli(amount)}</>;
};
